export default function isOverflowSet(overflowValue: string) {
    return (
        overflowValue === 'auto' ||
        overflowValue === 'hidden' ||
        overflowValue === 'scroll' ||
        overflowValue === 'overlay'
    )
}
